<template>
  <div class="tool-page ku-page">
    <div class="tool-content">
      <div class="tool-heading">
        <div>
          <h2>混剪协同</h2>
          <p>按项目整理素材，支持上传 / 图文素材 / 分享仓库 / 一键制作混剪视频</p>
        </div>
        <app-icon class="app-icon" name="inbox"></app-icon>
      </div>

      <!-- 无权限：整页显示锁定态（入口保留，进来后提示未开通，不再弹窗+跳回首页） -->
      <div v-if="locked" class="tool-card ku-locked">
        <div class="ku-locked-icon">
          <app-icon class="app-icon" name="lock"></app-icon>
        </div>
        <h3>混剪协同暂未开通</h3>
        <p>{{ lockMsg || '该功能当前只对指定用户开放。' }}</p>
        <div class="ku-locked-actions">
          <el-button size="small" @click="$router.push('/user2/index')">返回工作台</el-button>
        </div>
      </div>

      <div v-else class="tool-card ku-card">
        <!-- 手机端目录入口：做成明确的按钮（原来只显示当前项目名，和下面工具栏重复，看着不像能点） -->
        <button type="button" class="ku-dir-toggle" @click="dirOpen = true">
          <app-icon class="app-icon" name="folder_open"></app-icon>
          <span class="ku-dir-label">项目目录</span>
          <span class="ku-dir-count" v-if="projectTotal">{{ ku_files.length }}/{{ projectTotal }}</span>
          <app-icon class="app-icon ku-dir-arrow" name="chevron_right"></app-icon>
        </button>

        <!-- 项目目录：桌面为左侧栏，手机为抽屉（CSS 切换，DOM 不重建） -->
        <aside class="ku-side" :class="{ 'mobile-open': dirOpen }">
          <div class="ku-side-title">
            <app-icon class="app-icon" name="folder_open"></app-icon>
            <span>项目目录</span>
            <i class="el-icon-close ku-side-close" @click="dirOpen = false"></i>
          </div>
          <div class="ku-side-head">
            <el-input placeholder="搜索名称" v-model="filterText" size="small">
              <i class="el-icon-search" slot="suffix" style="padding-right:6px;padding-top:8px;font-size:16px;color:#94a3b8;"></i>
            </el-input>
            <el-button icon="el-icon-folder-add" plain class="ku-side-add" @click="cjwj = true"></el-button>
          </div>
          <div class="ku-side-count">
            <span v-if="projectTotal">共 {{ projectTotal }} 个项目</span>
            <span v-else>正在加载项目…</span>
          </div>
          <div class="ku-side-scroll" @scroll="onSideScroll">
            <el-tree ref="trees" :data="ku_files" :props="props" :load="loadNode" lazy highlight-current
              :filter-node-method="filterNode" @node-click="treeclick" node-key="id"
              :default-expanded-keys="defaultExpandIds" :default-checked-keys="defaultExpandIds">
              <span slot-scope="{ node }" class="ku-node">
                <span class="ku-node-name">
                  <i class="el-icon-folder-checked ku-shared" v-if="node.data.share == 1"></i>
                  <i class="el-icon-folder" v-else></i>
                  <span class="ku-node-text">{{ node.data.name }}</span>
                  <el-tag size="mini" type="info" v-if="node.data.num">{{ node.data.num }}</el-tag>
                </span>
                <!-- 项目操作收进「⋯」菜单：4 个图标并排会被侧栏宽度截断（删除图标被切掉） -->
                <el-dropdown v-if="node.data.parent == 0" class="ku-node-more" trigger="click"
                  placement="bottom-end" @click.native.stop @command="cmd => tree_action(cmd, node)">
                  <span class="ku-more-icon"><i class="el-icon-more"></i></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="share" icon="el-icon-share" :disabled="!canShare">
                      {{ canShare ? '分享项目' : '分享项目（无权限）' }}
                    </el-dropdown-item>
                    <el-dropdown-item command="refresh" icon="el-icon-refresh">刷新素材</el-dropdown-item>
                    <el-dropdown-item command="edit" icon="el-icon-edit">重命名</el-dropdown-item>
                    <el-dropdown-item command="del" icon="el-icon-delete" divided>删除项目</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </el-tree>
            <div class="ku-side-more">
              <span v-if="projectsLoading">加载中…</span>
              <button v-else-if="projectHasMore" type="button" class="ku-more-btn" @click="loadProjects(true)">
                加载更多（{{ ku_files.length }}/{{ projectTotal }}）
              </button>
              <span v-else-if="projectTotal">已全部加载（{{ projectTotal }} 个）</span>
            </div>
          </div>
        </aside>
        <div class="ku-mask" v-if="dirOpen" @click="dirOpen = false"></div>

        <!-- 素材区 -->
        <section class="ku-main">
          <template v-if="name_key">
            <div class="ku-toolbar">
              <div class="ku-toolbar-left">
                <span class="ku-title">{{ name_key }}</span>
              </div>
              <div class="ku-toolbar-actions">
                <el-button icon="el-icon-picture-outline-round" plain size="small" type="warning"
                  @click="share_cover = []; imgs_list(); share_cover_show = true">图文素材</el-button>
                <el-button icon="el-icon-edit" plain size="small" type="warning" @click="edit_title_fc">编辑文案</el-button>
                <el-button icon="el-icon-scissors" plain size="small" type="success" @click="make_video_fc">制作视频</el-button>
              </div>
            </div>

            <div class="ku-grid">
              <div class="ku-item ku-add-card">
                <!-- 上传链接添加：仅项目层可见，提交后由服务端解析链接并把视频切分成片段 -->
                <el-button v-if="spk_select.parent == 0" type="success" icon="el-icon-paperclip" size="small"
                  @click="open_link_dialog">上传链接添加</el-button>
                <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="upload_video = true">
                  上传视频添加</el-button>
                <div class="ku-add-tip" v-if="spk_select.parent == 0">*此页面上传将为您自动分割视频为片段</div>
              </div>

              <template v-if="!isProjectRoot">
                <div class="ku-item" v-for="(item, i) in spk_files" :key="i">
                  <div class="ku-thumb">
                    <!-- 用 cover 而不是 scale-down：素材缩略图常是窄的竖版小图，
                         scale-down 不会放大，会在卡片左右留白（宽度占不满） -->
                    <el-image class="ku-thumb-img" fit="cover" :src="item.image" v-if="item.type == 0"></el-image>
                    <el-image class="ku-thumb-img" fit="contain" :src="require('@/assets/img/music_file.png')" v-else>
                    </el-image>

                    <div class="ku-play" @click="lookvideo_fc(item)">
                      <i class="el-icon-video-play"></i>
                    </div>

                    <i class="el-icon-close ku-del" title="删除" @click.stop="del_video(item)"></i>
                    <el-checkbox class="ku-check" v-model="check_video" :label="item.id"
                      @change="checked => check_video_fc(checked, item.id)"></el-checkbox>
                    <i class="el-icon-download ku-down" title="下载" @click.stop="down_video(item)"></i>
                  </div>
                  <div class="ku-name" :title="item.name">{{ item.name }}</div>
                </div>
              </template>
            </div>

            <!-- 选中项目名：素材在各子目录里，这里给提示；分页只对子目录素材有意义 -->
            <div v-if="isProjectRoot" class="ku-root-hint">
              <app-icon class="app-icon" name="folder_open"></app-icon>
              <p>项目素材按片段存放在子目录，请在左侧展开选择 <b>开头 / 中间 / 结尾 / 音乐</b></p>
            </div>

            <template v-else>
              <!-- 批量操作条：复选框本来就在收集选中项，之前没有任何后续操作 -->
              <div v-if="check_video_new.length" class="ku-batch">
                <span class="ku-batch-count">已选 {{ check_video_new.length }} 项</span>
                <div class="ku-batch-actions">
                  <el-button size="mini" plain @click="select_all_page">全选本页</el-button>
                  <el-button size="mini" plain @click="clear_selection">取消选择</el-button>
                  <el-button size="mini" plain icon="el-icon-download" @click="batch_download">下载</el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" :loading="batchBusy"
                    @click="batch_remove">批量删除</el-button>
                </div>
              </div>

              <div class="ku-pager">
                <el-pagination background :small="isMobile" layout="total, prev, pager, next"
                  :page-size="filesPageSize" :total="total" :current-page="page" @current-change="fy_page">
                </el-pagination>
              </div>
            </template>
          </template>

          <div v-else class="ku-empty">
            <el-empty :image-size="isMobile ? 120 : 180">
              <el-button type="primary" @click="cjwj = true">立即创建您的视频项目</el-button>
            </el-empty>
          </div>
        </section>
      </div>
    </div>

    <el-dialog title="新建项目" :visible.sync="cjwj" :width="isMobile ? '90%' : '460px'">
      <el-form :model="cjwj_from" ref="cjwj_from" label-width="80px" class="demo-ruleForm" :rules="rules">
        <el-form-item label="项目名称" prop="wjname">
          <el-input v-model="cjwj_from.wjname" autocomplete="off" size="small" :maxlength="maxProjectNameLen"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 24px; margin-bottom: 0;">
          <el-button type="primary" @click="cjwj_fc('cjwj_from')" size="medium">创建</el-button>
          <el-button @click="cjwj = false" size="medium">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="分享项目" :visible.sync="share_show" :width="isMobile ? '92%' : '520px'">
      <!-- 失败原因内联展示：原来只弹一句 toast，弹窗里只剩个开关，用户不知道差什么 -->
      <el-alert v-if="shareError" class="ku-share-alert" type="warning" :closable="false" show-icon
        :title="shareError" description="分享要求：账号在分享白名单内，且项目素材 ≥10 个、至少 1 个音乐素材。"></el-alert>
      <div class="ku-share-tip">
        开启分享后该项目会公开到<b>聚合好物素材市场</b>（其他用户按下方点数消耗使用）。
      </div>
      <div>
        <el-switch inactive-text="开启分享" v-model="share_item.share" @change="share_open"></el-switch>
      </div>
      <div v-if="share_cover.length != 0">
        <div class="ku-row">
          <div class="ku-row-label">当前封面</div>
          <div>
            <div v-if="share_item.cover" class="ku-cover-now">
              <el-image style="width: 60px; height: 100px; border-radius: 5px;" fit="cover" :src="share_item.cover">
              </el-image>
              <div class="ku-cover-edit" @click="share_cover_show = true">修改</div>
            </div>
            <el-button size="mini" type="primary" @click="share_cover_show = true" v-else>立即设置</el-button>
          </div>
        </div>
        <div class="ku-row">
          <div class="ku-row-label">分类设置</div>
          <el-select v-model="share_item.type" placeholder="请选择" size="small">
            <el-option v-for="item in ku_type" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="ku-row">
          <div class="ku-row-label">消耗点数</div>
          <el-input-number size="mini" :min="0" v-model="share_item.surplus"></el-input-number>
          <span class="ku-share-unit">点 / 次</span>
        </div>
      </div>
      <div v-else-if="!shareError" class="ku-share-empty">开启分享后，在这里选择封面、分类与消耗点数</div>
      <div class="ku-dialog-footer" v-if="share_cover.length != 0">
        <el-button type="primary" @click="share_set">保存设置</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="is_imgs == 1 ? '图文素材' : '设置封面'" :visible.sync="share_cover_show"
      :width="isMobile ? '94%' : '720px'" :top="isMobile ? '6vh' : '12vh'">
      <!-- 图文素材：总数 + 批量删除工具条（原来一次只能删一张，还要点图下方的"删除"小字） -->
      <div v-if="is_imgs" class="ku-cover-bar">
        <span class="ku-cover-bar-total">共 {{ share_cover_total }} 张</span>
        <div class="ku-cover-bar-actions">
          <el-button size="mini" plain :disabled="!share_cover.length" @click="cover_select_all">全选本页</el-button>
          <el-button size="mini" plain :disabled="!coverSelected.length" @click="cover_clear_selection">取消选择</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" :loading="batchBusy"
            :disabled="!coverSelected.length" @click="batch_remove_imgs">批量删除</el-button>
        </div>
      </div>
      <!-- 设置封面：先展示当前封面 + 选取说明 -->
      <div v-else class="ku-cover-current">
        <div class="ku-cover-current-label">当前封面</div>
        <div class="ku-cover-current-body">
          <el-image v-if="share_item.cover" class="ku-cover-current-img" fit="cover" :src="share_item.cover"></el-image>
          <div v-else class="ku-cover-current-img ku-cover-current-none">未设置</div>
          <div class="ku-cover-current-tip">
            <p>点击下方图片即可替换封面，选好后自动返回上一页。</p>
            <p>展示按 3:5 竖版裁剪，建议选竖版图。</p>
          </div>
        </div>
      </div>

      <div v-if="share_cover.length" class="ku-cover-list">
        <div v-for="(item, index) in share_cover" :key="item.id || index" class="ku-cover-item">
          <div class="ku-cover-thumb" @click="cover_thumb_click(item, index)">
            <el-image style="width: 100%; height: 100%; border-radius: 6px;" fit="cover" :src="item.image"
              :preview-src-list="is_imgs ? coverPreviewList : []">
              <div slot="placeholder" class="ku-cover-skeleton"></div>
              <div slot="error" class="ku-cover-skeleton ku-cover-fail">加载失败</div>
            </el-image>

            <!-- 设置封面：鼠标移上去才显示"选它"，避免一直压暗图片 -->
            <div class="ku-cover-pick" v-if="!is_imgs"><i class="el-icon-thumb"></i></div>
            <!-- 图文素材：点击看大图（用 el-image 内置查看器，支持左右切换/缩放/ESC） -->
            <div class="ku-cover-zoom" v-else><i class="el-icon-zoom-in"></i></div>

            <!-- 当前封面高亮 -->
            <div v-if="!is_imgs && share_item.cover === item.image" class="ku-cover-selected">
              <i class="el-icon-check"></i>
            </div>

            <el-checkbox v-if="is_imgs" class="ku-cover-check" v-model="coverSelected" :label="item.id"
              @click.native.stop></el-checkbox>
            <i v-if="is_imgs" class="el-icon-close ku-cover-remove" title="删除这张图"
              @click.stop="del_img(item, index)"></i>
          </div>
        </div>
      </div>

      <div v-else class="ku-cover-empty">
        <app-icon class="app-icon" name="image"></app-icon>
        <p>{{ is_imgs ? '该项目还没有图文素材' : '暂时没有可选封面' }}</p>
        <p class="ku-cover-empty-sub">
          {{ is_imgs ? '图文素材由服务端在项目同步时生成，稍后刷新看看；也可以先直接上传视频素材。'
            : '封面取自项目「中间」目录的素材截图，先去「中间」目录上传素材试试。' }}
        </p>
      </div>

      <!-- 分页：page-size 与后端对齐（haowu_imgs paginate(12) / share_open paginate(8)） -->
      <div class="ku-pager ku-pager-dialog" v-if="share_cover_total > 0">
        <el-pagination background :small="isMobile" layout="total, prev, pager, next"
          :page-size="is_imgs == 1 ? imgsPageSize : coverPageSize" :total="share_cover_total"
          :current-page="share_cover_page" @current-change="fy_share_cover_page">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="制作视频" :visible.sync="make_video" :width="isMobile ? '92%' : '520px'">
      <makevideo_view :kuinfo="make_video_info" @done="make_video_wc"></makevideo_view>
    </el-dialog>

    <el-dialog title="上传视频" :visible.sync="upload_video" :width="isMobile ? '94%' : '520px'"
      custom-class="ku-upload-dlg">
      <upload_view :kuinfo="spk_select" :namekey="name_key" @uploaded="on_uploaded"></upload_view>
    </el-dialog>

    <el-dialog title="添加链接" :visible.sync="ku_add" :width="isMobile ? '94%' : '560px'" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="ku_add_close" custom-class="ku-link-dlg">
      <div class="ku-link-tip">
        <app-icon class="app-icon" name="link"></app-icon>
        <span>为「{{ spk_select.name }}」项目添加素材链接</span>
      </div>

      <div class="ku-link-panel">
        <div class="ku-link-head">
          <span class="ku-link-label">以链接添加<em>支持整段分享文案</em></span>
          <div class="ku-link-badges">
            <span class="ku-badge is-ok">识别 {{ linkParsed.valid }}</span>
            <span class="ku-badge is-warn" v-if="linkParsed.invalid">忽略 {{ linkParsed.invalid }}</span>
            <span class="ku-badge" v-if="linkParsed.dup">重复 {{ linkParsed.dup }}</span>
          </div>
        </div>
        <el-input class="ku-link-input" type="textarea" v-model="all_url" :autosize="{ minRows: 6, maxRows: 12 }"
          placeholder="一行一个链接；也支持直接粘贴整段分享文案（会自动提取其中的链接）" @keydown.native.ctrl.enter="ku_tjlj"></el-input>

        <div class="ku-quota">
          <div class="ku-quota-track">
            <div class="ku-quota-fill" :class="{ 'is-over': linkDirTotal + linkParsed.valid > maxProjectFiles }"
              :style="{ width: quotaPercent + '%' }"></div>
          </div>
          <div class="ku-quota-text">
            <span>项目素材 {{ linkDirTotal }}/{{ maxProjectFiles }}</span>
            <span class="ku-quota-over" v-if="linkDirTotal + linkParsed.valid > maxProjectFiles">超出上限，请先清理部分素材</span>
            <span class="ku-quota-tip" v-else-if="linkParsed.valid">提交后约 {{ linkDirTotal + linkParsed.valid }} 个</span>
          </div>
        </div>
      </div>

      <div class="ku-link-note">
        <app-icon class="app-icon" name="info"></app-icon>
        <div>
          <div>支持直接粘贴整段分享文案，会自动提取其中的链接</div>
          <div>提交后由服务端下载并切片，稍后自动出现在「开头 / 中间 / 结尾 / 音乐」目录</div>
        </div>
      </div>

      <div class="ku-link-switch">
        <div>
          <div class="ku-link-switch-title">提取视频为音乐</div>
          <div class="ku-link-switch-desc">同时把视频里的音频存为音乐素材</div>
        </div>
        <el-switch v-model="ku_add_music" active-color="#13ce66"></el-switch>
      </div>

      <div class="ku-dialog-footer">
        <el-button size="small" @click="ku_add = false">取消</el-button>
        <el-button type="success" size="small" :loading="linkSubmitting" :disabled="!linkParsed.valid"
          @click="ku_tjlj">添加{{ linkParsed.valid ? '（' + linkParsed.valid + '）' : '' }}</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑文案" :visible.sync="edit_title_show" :close-on-press-escape="false"
      :width="isMobile ? '94%' : '640px'" custom-class="ku-dlg">
      <!-- 标题/脚本切换 -->
      <div class="ku-title-tabs">
        <button type="button" class="ku-title-tab" :class="{ active: editTab === 'bt' }" @click="switch_tab('bt')">
          发布标题<span>{{ (edit_title_list.bt || []).length }}</span>
        </button>
        <button type="button" class="ku-title-tab" :class="{ active: editTab === 'jb' }" @click="switch_tab('jb')">
          文案脚本<span>{{ (edit_title_list.jb || []).length }}</span>
        </button>
      </div>

      <div class="ku-title-head">
        <span class="ku-title-head-text">{{ editTab === 'bt' ? '发布标题' : '文案脚本' }}</span>
        <el-button type="warning" plain size="mini" icon="el-icon-plus" @click="start_new">新建</el-button>
      </div>

      <!-- 新建（内联编辑，不再叠一层弹窗） -->
      <div v-if="editingKey === 'new'" class="ku-text-item ku-text-item-new">
        <el-input ref="editBox" type="textarea" v-model="editingText" :autosize="{ minRows: 3, maxRows: 10 }"
          :placeholder="editTab === 'bt' ? '请输入发布标题' : '请输入文案脚本'"
          @keydown.native.ctrl.enter="save_edit(null)"></el-input>
        <div class="ku-title-editor-actions">
          <span class="ku-text-len">{{ editingText.length }} 字 · Ctrl+Enter 保存</span>
          <el-button size="mini" @click="cancel_edit">取消</el-button>
          <el-button size="mini" type="primary" @click="save_edit(null)">保存</el-button>
        </div>
      </div>

      <div v-if="!currentList.length && editingKey !== 'new'" class="ku-title-empty">
        还没有{{ editTab === 'bt' ? '发布标题' : '文案脚本' }}，点右上角「新建」添加
      </div>

      <div v-for="(item, index) in currentList" :key="editTab + '-' + index" class="ku-text-item"
        :class="{ 'ku-text-item-editing': editingKey === editTab + '-' + index }">
        <!-- 编辑中：原地变成输入框（纵向排布，输入框占满整行） -->
        <template v-if="editingKey === editTab + '-' + index">
          <el-input ref="editBox" type="textarea" v-model="editingText" :autosize="{ minRows: 3, maxRows: 10 }"
            @keydown.native.ctrl.enter="save_edit(item)"></el-input>
          <div class="ku-title-editor-actions">
            <span class="ku-text-len">{{ editingText.length }} 字 · Ctrl+Enter 保存</span>
            <el-button size="mini" @click="cancel_edit">取消</el-button>
            <el-button size="mini" type="primary" @click="save_edit(item)">保存</el-button>
          </div>
        </template>
        <template v-else>
          <!-- 正文占满整行；字数与操作放到卡片底部一行，避免右侧被挤出一条宽栏 -->
          <div class="ku-text-body">{{ item.text }}</div>
          <div class="ku-text-side">
            <span class="ku-text-len">{{ (item.text || '').length }} 字</span>
            <div class="ku-text-ops">
              <i class="el-icon-copy-document ku-text-op" title="复制" @click="copy_text(item.text)"></i>
              <i class="el-icon-edit ku-text-op ku-text-edit" title="编辑" @click="start_edit(item, index)"></i>
              <i class="el-icon-delete ku-text-op ku-text-del" title="删除" @click="del_title(item, index)"></i>
            </div>
          </div>
        </template>
      </div>

      <div class="ku-dialog-footer">
        <el-button @click="edit_title_show = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 视频预览 -->
    <div class="ku-viewer" v-if="lookvideo">
      <div class="ku-viewer-mask" @click="lookvideo_close"></div>
      <div class="ku-viewer-body">
        <i class="el-icon-close ku-viewer-close" @click="lookvideo_close"></i>
        <video :src="lookvideo_src.video" controls="controls" controlslist="nodownload"></video>
        <div class="ku-viewer-name">{{ lookvideo_src.name }}</div>
        <el-button size="medium" icon="el-icon-download" type="primary" @click="down_video(lookvideo_src)">下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 2.0 版混剪协同：界面按 2.0 风格重做并适配手机端，业务逻辑复用 1.0（User/Ku.vue）；
// 制作设置与上传用 2.0 版子组件（接口已切新后端，并用 $emit 代替原来的 $parent 深链）。
import LegacyKu from '../User/Ku.vue'
import KuMakevideo from './Ku_makevideo.vue'
import KuUpload from './Ku_upload.vue'

export default {
  name: 'User2Ku',
  extends: LegacyKu,
  components: {
    makevideo_view: KuMakevideo,
    upload_view: KuUpload
  },
  data() {
    return {
      // 手机端目录抽屉开关
      dirOpen: false,
      isMobile: false,
      // 当前选中的是「项目名」本身（老代码这里叫"制作完成视频"，入口已下线）
      isProjectRoot: false,
      // 分享白名单：新后端 /ku/projects 返回 can_share（对齐老 PHP 只允许 uid 2/38646）
      canShare: true,
      // 分享失败原因：内联展示，替代"只有一句 toast"
      shareError: '',
      // 批量操作进行中
      batchBusy: false,
      // 图文素材弹窗里勾选的图片 id
      coverSelected: [],
      // 编辑文案弹窗：当前 tab（bt=发布标题 jb=文案脚本）、正在编辑的项、编辑中的文本
      editTab: 'bt',
      editingKey: '',
      editingText: '',
      // 项目名上限（yh_ku_list.name 是 varchar(10)，与后端校验一致）
      maxProjectNameLen: 10,
      // 链接添加弹窗：项目素材数上限（与后端 MAX_PROJECT_FILES 一致）、各目录素材合计、提交中
      maxProjectFiles: 500,
      linkDirTotal: 0,
      linkSubmitting: false,
      // 未开通混剪协同（后端返回 status:100）：整页显示锁定态
      locked: false,
      lockMsg: '',
      // 与后端分页对齐（qhy_php/qhy/controller/Spk.php: get_files paginate(11)、share_open paginate(8)；
      // Haowu.php: haowu_imgs paginate(12)）
      filesPageSize: 11,
      coverPageSize: 8,
      imgsPageSize: 12,
      // 项目列表分页（新后端 /api/v1/users/ku/projects，30 条/页，替代老 PHP 的 limit(300) 硬截断）
      projectPageSize: 30,
      projectPage: 0,
      projectTotal: 0,
      projectHasMore: false,
      projectsLoading: false
    }
  },
  computed: {
    // 图文素材大图预览的图片列表（el-image 内置查看器按它做左右切换）
    coverPreviewList() {
      return (this.share_cover || []).map(item => item.image)
    },
    // 编辑文案弹窗当前 tab 的列表
    currentList() {
      const list = this.edit_title_list || {}
      return (this.editTab === 'bt' ? list.bt : list.jb) || []
    },
    // 链接解析：与后端同源的「从文本里抠链接」方式。
    // 抖音/快手的分享是一整段话 + 一个链接（如「3.02 Ehb:/ … https://v.douyin.com/xxx/ 复制此链接…」），
    // 若按「整行是否以 http 开头」判断会把这种情况误判成无链接，导致提交按钮被禁用。
    linkParsed() {
      const raw = String(this.all_url || '')
      const found = raw.match(/https?:\/\/[^\s"'<>#，。！？、；：（）【】\u4e00-\u9fa5\uff00-\uffef]+/g) || []
      const seen = {}
      let dup = 0
      found.forEach(url => {
        if (seen[url]) {
          dup += 1
        } else {
          seen[url] = 1
        }
      })
      // 「忽略」= 非空但整行没有链接的行（纯文案行）
      const ignored = raw.split(/[\r\n]+/).map(s => s.trim()).filter(Boolean)
        .filter(line => !/https?:\/\//i.test(line)).length
      return { valid: Object.keys(seen).length, dup: dup, invalid: ignored }
    },
    // 素材额度进度（超过上限按 100% 显示，样式变红）
    quotaPercent() {
      const used = this.linkDirTotal + this.linkParsed.valid
      if (!this.maxProjectFiles) return 0
      return Math.min(100, Math.round(used / this.maxProjectFiles * 100))
    }
  },
  methods: {
    // 手机端选中目录后自动收起抽屉；点「项目名」时不再拼" / 制作完成视频"（该入口已下线）
    treeclick(data, node = '') {
      const isProjectRoot = !node || !(node.parent && node.parent.data && node.parent.data.name)
      LegacyKu.methods.treeclick.call(this, data, node)
      if (isProjectRoot) {
        this.name_key = data.name
      }
      this.isProjectRoot = isProjectRoot
      this.dirOpen = false
      this.clear_selection()
    },
    // 翻页也清空选择，避免选中项跨页残留
    fy_page(e) {
      this.clear_selection()
      this.tree_get_file(e)
      this.page = e
    },
    // 「⋯」菜单分发（原来 4 个图标并排会被侧栏宽度截断）
    tree_action(command, node) {
      if (command === 'share') {
        this.tree_share(node)
      } else if (command === 'refresh') {
        this.tree_refresh(node)
      } else if (command === 'edit') {
        this.rename_project(node)
      } else if (command === 'del') {
        this.tree_del(node)
      }
    },
    // 重命名项目（老代码 tree_edit 是空实现，接口也是新后端新增的）
    rename_project(node) {
      const project = (node && node.data) || {}
      if (!project.id) return
      const oldName = project.name || ''
      this.$prompt('项目名称（最长 ' + this.maxProjectNameLen + ' 个字符）', '重命名项目', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputValue: oldName,
        inputValidator: (value) => {
          const text = String(value == null ? '' : value).trim()
          if (!text) return '名称不能为空'
          if (text.length > this.maxProjectNameLen) return '名称最长 ' + this.maxProjectNameLen + ' 个字符'
          return true
        }
      }).then(({ value }) => {
        const name = String(value || '').trim()
        if (name === oldName) return
        const loading = this.$loading(this.$loadinginfo)
        this.$ajax.post('api/v1/users/ku/project-rename', { id: project.id, name: name }).then(res => {
          const body = res.data || {}
          if (body.status == 200) {
            const newName = (body.data && body.data.name) || name
            // 树节点、列表项、以及按名字查项目的引用都要同步（链接添加是按 kuname 查库的）
            this.$set(project, 'name', newName)
            const row = (this.ku_files || []).find(item => item.id === project.id)
            if (row && row !== project) this.$set(row, 'name', newName)
            if (this.spk_parent_select && this.spk_parent_select.id === project.id) {
              this.$set(this.spk_parent_select, 'name', newName)
            }
            if (this.spk_select && this.spk_select.id === project.id) {
              this.$set(this.spk_select, 'name', newName)
            }
            if (this.name_key && oldName && this.name_key.indexOf(oldName) === 0) {
              this.name_key = newName + this.name_key.slice(oldName.length)
            }
            this.$toast.show('重命名成功', 2000)
          } else {
            this.$msg.error(body.msg)
          }
          loading.close()
        }).catch(() => {
          loading.close()
          this.$msg.error('重命名失败，请重试')
        })
      }).catch(() => { })
    },
    // 每次打开分享弹窗先清掉上次的失败原因
    tree_share(node) {
      this.shareError = ''
      LegacyKu.methods.tree_share.call(this, node)
    },
    // 分享开关：走新后端 /ku/share（返回 data.list / data.total；失败原因留在弹窗里）
    share_open(e, page = 1) {
      this.is_imgs = 0
      this.share_cover_page = page
      const loading = this.$loading(this.$loadinginfo)
      const data = this.share_item || {}
      this.$ajax.post(`api/v1/users/ku/share?page=${page}`, { id: data.id, share: !!e }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.shareError = ''
          const payload = body.data || {}
          this.share_cover = payload.list || []
          this.share_cover_total = payload.total || 0
        } else {
          this.share_item.share = false
          this.share_cover = []
          this.share_cover_total = 0
          this.shareError = body.msg || '分享失败'
          this.$msg.error(body.msg)
        }
        loading.close()
      }).catch(() => {
        loading.close()
        this.shareError = '分享失败，请重试'
      })
    },
    // 保存分享设置：走新后端 /ku/share-set（补成功反馈）
    share_set() {
      if (this.share_item.cover == '' || this.share_item.type == '') {
        this.$msg.error('未设置封面和类型')
        return
      }
      const loading = this.$loading(this.$loadinginfo)
      this.$ajax.post('api/v1/users/ku/share-set', {
        id: this.share_item.id,
        cover: this.share_item.cover || '',
        surplus: this.share_item.surplus,
        type: this.share_item.type
      }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.share_show = false
          this.$msg.success('分享设置已保存')
        } else {
          this.shareError = body.msg || '保存失败'
          this.$msg.error(body.msg)
        }
        loading.close()
      }).catch(() => {
        loading.close()
        this.shareError = '保存失败，请重试'
      })
    },
    // 批量选择：页面上本来就有复选框在收集选中项，但没有任何批量操作
    clear_selection() {
      this.check_video = []
      this.check_video_new = []
    },
    select_all_page() {
      this.check_video = this.spk_files.map(item => item.id)
      this.check_video_new = this.spk_files.slice()
    },
    // 批量下载：浏览器会拦截连续弹窗，这里间隔打开（仍可能被拦截，属浏览器限制）
    batch_download() {
      const items = this.check_video_new || []
      items.forEach((item, i) => {
        setTimeout(() => window.open(item.video, '_blank'), i * 400)
      })
    },
    // 批量删除：老接口是单条删除，这里顺序串行执行并汇总结果
    batch_remove() {
      const items = (this.check_video_new || []).slice()
      if (!items.length || this.batchBusy) return
      this.$confirm('确定删除选中的 ' + items.length + ' 个素材？删除后不可恢复。', '批量删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchBusy = true
        let ok = 0
        const next = (i) => {
          if (i >= items.length) {
            this.batchBusy = false
            this.$msg.success('批量删除完成：成功 ' + ok + ' / ' + items.length)
            const lastPage = Math.max(1, Math.ceil((this.total - ok) / this.filesPageSize))
            this.page = Math.min(this.page, lastPage)
            this.clear_selection()
            this.tree_get_file(this.page)
            return
          }
          this.$ajax.post('api/v1/users/ku/delete', items[i]).then(res => {
            const body = res.data || {}
            if (body.status == 200) {
              ok += 1
            } else if (body.msg) {
              this.$msg.error(body.msg)
            }
          }).catch(() => { }).then(() => next(i + 1))
        }
        next(0)
      }).catch(() => { })
    },
    // 子目录：新后端 GET /ku/dirs（替代老 PHP /qhy/spk/get_dir）
    tree_get_dir(item, resolve = '') {
      this.$ajax.get(`api/v1/users/ku/dirs?id=${item.id}`).then(res => {
        const body = res.data || {}
        if (body.status != 200) {
          this.$msg.error(body.msg)
          return
        }
        const dirs = body.dir || []
        if (resolve === '') {
          this.$set(item, 'dir', [])
          dirs.forEach(one => {
            one['leaf'] = true
            item.dir.push(one)
          })
          this.$msg.success('获取目录成功')
        } else {
          resolve(dirs)
        }
      })
    },
    // 素材列表：新后端 POST /ku/files（替代老 PHP /qhy/spk/get_files），11 条/页与后端一致
    tree_get_file(page, show = 0) {
      this.$ajax.post(`api/v1/users/ku/files?page=${page}`, this.spk_select || {}).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.spk_files = body.list || []
          this.total = body.total || 0
          if (show == 1) {
            this.$msg.success(body.msg)
          }
        } else {
          this.$msg.error(body.msg)
        }
      })
    },
    // created() 里被调用（沿用老方法名）：项目列表走新后端分页接口
    ku_list_files() {
      this.loadProjects(false)
    },
    // 上传成功后直接刷新当前素材列表（老实现只能等 5 秒轮询）
    on_uploaded() {
      if (this.name_key) {
        this.tree_get_file(this.page)
      }
    },
    // 新建项目：逻辑同 1.0，差别是新建后要让左侧树真的出现该节点
    // （老代码只 unshift 数组，而 el-tree 对 data 不是深监听，节点不会渲染）
    ku_cjwj(name) {
      const loading = this.$loading(this.$loadinginfo)
      this.$ajax.post('api/v1/users/ku/project-create', { name: name }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.cjwj = false
          this.cjwj_from.wjname = ''
          this.$msg.success(body.msg)
          const created = body.data || {}
          const item = { id: created.id, name: created.name, uid: created.uid, parent: 0 }
          if (item.id && !this.ku_files.some(exist => exist.id === item.id)) {
            this.ku_files.unshift(item)
            this.projectTotal += 1
            this.prependProjectNode(item)
          }
          this.treeclick(item)
        } else {
          this.$msg.error(body.msg)
        }
      }).catch(() => {
        this.$msg.error('创建失败，请重试')
      }).finally(() => {
        loading.close()
      })
    },
    // 打开「添加链接」：顺带取一次项目各目录素材数，用于显示「已有 X/500」
    open_link_dialog() {
      this.ku_add = true
      this.linkDirTotal = 0
      const projectId = (this.spk_select || {}).id
      if (!projectId) return
      this.$ajax.get(`api/v1/users/ku/dirs?id=${projectId}`).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.linkDirTotal = (body.dir || []).reduce((sum, item) => sum + (Number(item.num) || 0), 0)
        }
      }).catch(() => { })
    },
    // 链接添加：走新后端 /ku/url-add（只写队列，服务端异步下载切片）
    ku_tjlj() {
      const parsed = this.linkParsed
      if (this.linkSubmitting) return
      if (!String(this.all_url || '').trim()) {
        this.$msg.error('请填写视频链接')
        return
      }
      if (!parsed.valid) {
        this.$msg.error('没有识别到链接（分享文案里需带 http:// 或 https:// 地址）')
        return
      }
      if (this.linkDirTotal + parsed.valid > this.maxProjectFiles) {
        this.$msg.error('超出项目素材上限（' + this.maxProjectFiles + ' 个），请先清理部分素材')
        return
      }
      this.linkSubmitting = true
      this.$ajax.post('api/v1/users/ku/url-add', {
        kuname: (this.spk_parent_select || {}).name,
        all_url: this.all_url,
        ku_ismusic: this.ku_add_music
      }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.$msg.success('已提交，服务端解析切片中，稍后会自动出现在对应目录')
          this.ku_add = false
          this.all_url = ''
        } else {
          this.$msg.error(body.msg)
        }
      }).catch(() => {
        this.$msg.error('提交失败，请重试')
      }).finally(() => {
        this.linkSubmitting = false
      })
    },
    // 分享分类：复用新后端已有的 /haowu/types（返回的是字符串数组，这里转成 {name} 供下拉使用）
    ku_type_list() {
      this.$ajax.get('api/v1/users/haowu/types').then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.ku_type = (body.data || []).map(name => ({ name: name }))
        }
      }).catch(() => { })
    },
    // 把新项目插到根节点最前（拿第二个节点当参照；树里还没有节点时退回 append）
    prependProjectNode(item) {
      const tree = this.$refs.trees
      if (!tree || !tree.store || !tree.store.root) return
      const ref = this.ku_files[1]
      const refNode = ref ? tree.store.getNode(ref.id) : null
      if (refNode && refNode.parent) {
        tree.insertBefore(item, ref.id)
      } else {
        tree.append(item, tree.store.root)
      }
    },
    // 删除素材 / 删除项目：改走新后端 /ku/delete（覆盖老 PHP del_video 的两条分支）
    // type=1 表示删的是项目节点（要同步动树的节点），否则按删素材处理
    del_video(e, type = 0, node = '') {
      this.$confirm('此操作将永久删除 "' + ((e && e.name) || '') + '"，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading(this.$loadinginfo)
        this.$ajax.post('api/v1/users/ku/delete', { id: e && e.id, url: (e && e.url) || '' }).then(res => {
          const body = res.data || {}
          if (body.status == 200) {
            if (type == 1) {
              // 删项目：同步移除左侧树节点与列表项
              if (this.spk_select && node && this.spk_select.id == node.data.id) {
                this.name_key = ''
                this.spk_select = []
                this.isProjectRoot = false
              }
              const tid = node && node.data && node.data.id
              const parent = node && node.parent
              const children = parent && parent.data
              const index = Array.isArray(children) ? children.findIndex(d => d.id === tid) : -1
              if (index > -1) children.splice(index, 1)
              const row = (this.ku_files || []).findIndex(item => item.id === tid)
              if (row > -1) this.ku_files.splice(row, 1)
              if (this.projectTotal > 0) this.projectTotal -= 1
              if (parent) {
                parent.loaded = false
                parent.expand()
              }
            } else {
              this.tree_get_file(this.page)
            }
            this.$msg.success(body.msg)
          } else {
            this.$msg.error(body.msg)
          }
        }).catch(() => {
          this.$msg.error('删除失败，请重试')
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    // 轮询刷新：老实现每 5 秒无条件重取当前页，而每次签名 URL 都带新时间戳，
    // 等于每 5 秒把整页图片重下一遍。这里改成「内容变了才替换」，并跳过后台标签页。
    // 另外不再调 pd()：制作点数已不展示，队列位次前端也不用，省掉一次老接口请求。
    jiance() {
      this.dsq_time = this.common.time_10() + 1800
      this.cleartime = 0
      this.timer = setInterval(() => {
        if (this.cleartime == 1 || this.dsq_time < this.common.time_10()) {
          clearInterval(this.timer)
          this.timer = null
          return
        }
        if (document.hidden) return
        this.refreshFilesIfChanged()
      }, 5000)
    },
    refreshFilesIfChanged() {
      if (!this.spk_select || !this.name_key) return
      const page = this.page
      this.$ajax.post(`api/v1/users/ku/files?page=${page}`, this.spk_select || {}).then(res => {
        const body = res.data || {}
        if (body.status != 200) return
        const list = body.list || []
        const first = list[0] || {}
        const current = this.spk_files[0] || {}
        const changed = list.length !== this.spk_files.length ||
          first.id !== current.id ||
          Number(body.total) !== Number(this.total)
        if (changed) {
          this.spk_files = list
          this.total = body.total || 0
        }
      })
    },
    // 项目目录列表：新后端真分页（老 PHP ku_list_files 是 limit(300) 硬截断，且不返回 total）
    loadProjects(append = false) {
      if (this.projectsLoading) return
      if (append && !this.projectHasMore) return
      const page = append ? this.projectPage + 1 : 1
      this.projectsLoading = true
      this.$ajax.get(`api/v1/users/ku/projects?page=${page}&page_size=${this.projectPageSize}`).then(res => {
        const body = res.data || {}
        if (body.status != 200) {
          if (append) {
            this.$msg.error(body.msg)
          } else {
            // 未开通（yh_business.ku_xm <= 0）：整页显示锁定态，不弹窗、不跳转
            this.locked = true
            this.lockMsg = body.msg || ''
            this.ku_files = []
            this.projectTotal = 0
          }
          return
        }
        this.locked = false
        const data = body.data || {}
        const list = data.list || []
        this.canShare = body.can_share !== false
        this.projectTotal = Number(data.total) || 0
        this.projectPage = page
        this.projectHasMore = page * this.projectPageSize < this.projectTotal
        if (append) {
          this.appendProjects(list)
        } else {
          // 赋新数组：el-tree 监听到 data 变化会按新数组重建根节点
          this.ku_files = list
        }
      }).catch(() => {
        if (!append) this.$msg.error('项目列表加载失败')
      }).finally(() => {
        this.projectsLoading = false
      })
    },
    // el-tree 对 data 不是深监听：直接 push 不会渲染，追加的根节点要用 append() 挂上去
    appendProjects(list) {
      const tree = this.$refs.trees
      list.forEach(item => {
        if (this.ku_files.some(exist => exist.id === item.id)) return
        this.ku_files.push(item)
        if (tree && tree.store && tree.store.root) {
          tree.append(item, tree.store.root)
        }
      })
    },
    // 目录栏滚到底部：自动加载下一页
    onSideScroll(e) {
      const el = e.target
      if (!el || !this.projectHasMore || this.projectsLoading) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
        this.loadProjects(true)
      }
    },
    // 缩略图点击：设置封面模式=选中该封面；图文素材模式交给 el-image 内置大图查看器
    cover_thumb_click(item, index) {
      if (this.is_imgs) return
      this.share_cover_set(item)
    },
    cover_select_all() {
      this.coverSelected = (this.share_cover || []).map(item => item.id)
    },
    cover_clear_selection() {
      this.coverSelected = []
    },
    // 批量删除图文素材：老接口只能单张删，这里串行执行并汇总结果
    batch_remove_imgs() {
      const ids = (this.coverSelected || []).slice()
      if (!ids.length || this.batchBusy) return
      const items = (this.share_cover || []).filter(item => ids.indexOf(item.id) > -1)
      if (!items.length) return
      this.$confirm('确定删除选中的 ' + items.length + ' 张图文素材？删除后不可恢复。', '批量删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchBusy = true
        let ok = 0
        const next = (i) => {
          if (i >= items.length) {
            this.batchBusy = false
            this.$msg.success('批量删除完成：成功 ' + ok + ' / ' + items.length)
            this.coverSelected = []
            const lastPage = Math.max(1, Math.ceil((this.share_cover_total - ok) / this.imgsPageSize))
            this.imgs_list(Math.min(this.share_cover_page, lastPage))
            return
          }
          this.$ajax.post('api/v1/users/ku/imgs-del', { id: items[i].id }).then(res => {
            const body = res.data || {}
            if (body.status == 200) {
              ok += 1
            } else if (body.msg) {
              this.$msg.error(body.msg)
            }
          }).catch(() => { }).then(() => next(i + 1))
        }
        next(0)
      }).catch(() => { })
    },
    // 图文素材列表：改走新后端 /haowu/imgs（图文素材本就是「聚合好物」的一部分，
    // 新后端早已迁完，返回结构是 data.list / data.total；同时不再往树节点数据里写 id
    imgs_list(page = 1) {
      this.is_imgs = 1
      this.share_cover_page = page
      this.coverSelected = []
      const loading = this.$loading(this.$loadinginfo)
      const current = this.spk_select || {}
      const kuid = current.parent ? current.parent : current.id
      this.$ajax.post(`api/v1/users/haowu/imgs?page=${page}`, { id: kuid }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          const data = body.data || {}
          this.share_cover = data.list || []
          this.share_cover_total = data.total || 0
        } else {
          this.share_cover = []
          this.share_cover_total = 0
          this.$msg.error(body.msg)
        }
        loading.close()
      })
    },
    // 打开编辑文案：重置 tab 与编辑态；列表改走新后端 /haowu/text
    // 顺带修老 bug：子目录选中时老代码传的是 spk_select.id（1..4），只有选「项目名」时才等于 kuid，
    // 所以在子目录里点「编辑文案」是查不到数据的。这里统一传项目 id。
    edit_title_fc() {
      this.editTab = 'bt'
      this.cancel_edit()
      this.edit_title_show = true
      const current = this.spk_select || {}
      const kuid = current.parent ? current.parent : current.id
      this.$ajax.post('api/v1/users/haowu/text', { id: kuid }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.edit_title_list.bt = body.bt || []
          this.edit_title_list.jb = body.jb || []
        } else {
          this.$msg.error(body.msg)
        }
      })
    },
    switch_tab(tab) {
      this.editTab = tab
      this.cancel_edit()
    },
    start_new() {
      this.editingKey = 'new'
      this.editingText = ''
      this.focus_editor()
    },
    start_edit(item, index) {
      this.editingKey = this.editTab + '-' + index
      this.editingText = item.text || ''
      this.focus_editor()
    },
    // 进入编辑态后自动聚焦输入框
    focus_editor() {
      this.$nextTick(() => {
        const box = this.$refs.editBox
        const input = Array.isArray(box) ? box[0] : box
        if (input && input.focus) input.focus()
      })
    },
    cancel_edit() {
      this.editingKey = ''
      this.editingText = ''
    },
    // 保存：走新后端 /ku/text-save（新建 {kuid,type,text}；编辑 {id,kuid,type,text}）
    save_edit(item) {
      const text = (this.editingText || '').trim()
      if (!text) {
        this.$msg.error('内容不能为空')
        return
      }
      const type = this.editTab === 'bt' ? 1 : 2
      const isNew = !item || !item.id
      const kuid = (item && item.kuid) || (this.spk_select && (this.spk_select.parent || this.spk_select.id))
      const payload = isNew
        ? { kuid: kuid, type: type, text: text }
        : { id: item.id, kuid: kuid, type: type, text: text }
      this.$ajax.post('api/v1/users/ku/text-save', payload).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          if (isNew) {
            const created = body.data || payload
            if (type === 1) {
              this.edit_title_list.bt.push(created)
            } else {
              this.edit_title_list.jb.push(created)
            }
            this.$toast.show('新建成功', 2000)
          } else {
            item.text = text
            this.$toast.show('更新成功', 2000)
          }
          this.cancel_edit()
        } else {
          this.$msg.error(body.msg)
        }
      })
    },
    // 删除文案：走新后端 /ku/text-del（带归属校验）
    del_title(item, index) {
      this.cancel_edit()
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('api/v1/users/ku/text-del', { id: item.id }).then(res => {
          const body = res.data || {}
          if (body.status == 200) {
            this.$toast.show('删除成功', 2000)
            if (item.type == 1) {
              this.edit_title_list.bt.splice(index, 1)
            } else if (item.type == 2) {
              this.edit_title_list.jb.splice(index, 1)
            }
          } else {
            this.$msg.error(body.msg)
          }
        }).catch(() => {
          this.$msg.error('删除失败，请重试')
        })
      }).catch(() => { })
    },
    // 复制（不依赖 common.js 的 copyText：那是未提交的 WIP）
    copy_text(text) {
      const value = String(text == null ? '' : text)
      if (!value) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(() => {
          this.$toast.show('已复制', 1500)
        }).catch(() => {
          this.copy_text_fallback(value)
        })
      } else {
        this.copy_text_fallback(value)
      }
    },
    copy_text_fallback(value) {
      const ta = document.createElement('textarea')
      ta.value = value
      ta.style.position = 'fixed'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$toast.show('已复制', 1500)
      } catch (e) {
        this.$msg.error('复制失败，请手动选择文本')
      }
      document.body.removeChild(ta)
    },
    // 删除图文素材后重取当前页；末页删空则回退到上一页
    del_img(item, index) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('api/v1/users/ku/imgs-del', { id: item.id }).then(res => {
          if (res.data.status == 200) {
            this.$toast.show('删除成功', 2000)
            const lastPage = Math.max(1, Math.ceil((this.share_cover_total - 1) / this.imgsPageSize))
            this.imgs_list(Math.min(this.share_cover_page, lastPage))
          } else {
            this.$msg.error(res.data.msg)
          }
        })
      }).catch(() => { })
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 900
    }
  },
  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport)
  }
}
</script>

<style scoped>
.tool-page {
  min-height: 100%;
  padding: 24px 24px 48px;
  background: #f5f7fa;
  box-sizing: border-box;
}

.tool-content {
  max-width: 1240px;
  margin: 0 auto;
}

.tool-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.tool-heading h2 {
  margin: 0 0 6px;
  color: #1e293b;
  font-size: 22px;
}

.tool-heading p {
  margin: 0;
  color: #94a3b8;
  font-size: 13px;
}

.tool-heading .app-icon {
  padding: 11px;
  border-radius: 12px;
  background: #e8f1fe;
  color: #1a73e8;
  font-size: 28px;
}

/* 卡片 */
.tool-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, .04);
}

.ku-card {
  display: flex;
  /* 桌面端固定在一屏内的高度：左右两栏各自内部滚动，整页不跟着变长 */
  height: calc(100vh - 200px);
  height: calc(100dvh - 200px);
  min-height: 420px;
  overflow: hidden;
}

/* 未开通：整页锁定态 */
.ku-locked {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 460px;
  padding: 40px 24px;
  text-align: center;
}

.ku-locked-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f1f5f9;
}

.ku-locked-icon .app-icon {
  font-size: 30px;
  color: #94a3b8;
}

.ku-locked h3 {
  margin: 6px 0 0;
  color: #1e293b;
  font-size: 17px;
}

.ku-locked p {
  margin: 0;
  max-width: 320px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.7;
}

.ku-locked-actions {
  margin-top: 10px;
}

/* 目录栏 */
.ku-side {
  display: flex;
  flex: 0 0 248px;
  flex-direction: column;
  width: 248px;
  height: 100%;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
  overflow: hidden;
}

.ku-side-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px 8px;
}

.ku-side-head /deep/ .el-input {
  flex: 1;
  min-width: 0;
}

.ku-side-add {
  flex: none;
  padding: 7px 9px;
  font-size: 16px;
}

.ku-side-count {
  padding: 0 12px 8px;
  color: #94a3b8;
  font-size: 12px;
}

.ku-side-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 8px 12px;
}

/* 触底加载：底部提示 / 加载更多按钮 */
.ku-side-more {
  padding: 6px 4px 2px;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
}

.ku-more-btn {
  width: 100%;
  padding: 7px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #1a73e8;
  font-size: 12px;
  cursor: pointer;
  transition: all .2s;
}

.ku-more-btn:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}

/* 滚动条美化：细瘦、低对比、去掉系统箭头按钮（Firefox 走 thin/color） */
.ku-side-scroll,
.ku-main {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.ku-side-scroll::-webkit-scrollbar,
.ku-main::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.ku-side-scroll::-webkit-scrollbar-track,
.ku-main::-webkit-scrollbar-track,
.ku-side-scroll::-webkit-scrollbar-corner,
.ku-main::-webkit-scrollbar-corner {
  background: transparent;
}

.ku-side-scroll::-webkit-scrollbar-thumb,
.ku-main::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #cbd5e1;
}

.ku-side-scroll::-webkit-scrollbar-thumb:hover,
.ku-main::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.ku-side-scroll::-webkit-scrollbar-button,
.ku-main::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.ku-node {
  display: flex;
  /* 不能写 width:100%：同级还有 Element 的展开箭头(约 24px)，两者一起会超宽被 flex-shrink
     压掉约 23px，右侧就空出一大块。用 flex:1 吃掉箭头之外的剩余宽度。 */
  flex: 1;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  padding-right: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.ku-node-name {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 4px;
  min-width: 0;
}

.ku-node-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ku-shared {
  color: #22c55e;
}

/* 项目操作：单个「⋯」按钮（常驻，触屏也能点到），菜单挂在 body 上不受侧栏宽度裁剪 */
.ku-node-more {
  flex: none;
  margin-left: 4px;
}

.ku-more-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  transition: all .2s;
}

.ku-more-icon i {
  font-size: 16px;
  font-weight: 600;
}

.ku-more-icon:hover {
  background: #e2e8f0;
  color: #1a73e8;
}

.ku-mask {
  display: none;
}

.ku-dir-toggle {
  display: none;
}

/* 侧栏标题（手机抽屉用；桌面侧栏本身一直可见，标题也不碍事） */
.ku-side-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 12px 0;
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.ku-side-title .app-icon {
  font-size: 17px;
  color: #1a73e8;
}

.ku-side-close {
  display: none;
  margin-left: auto;
  padding: 4px;
  border-radius: 6px;
  color: #94a3b8;
  font-size: 15px;
  cursor: pointer;
}

.ku-side-close:hover {
  background: #e2e8f0;
  color: #1a73e8;
}

/* 素材区 */
.ku-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 16px 18px 18px;
  overflow-y: auto;
}

.ku-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.ku-toolbar-left {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

.ku-title {
  max-width: 100%;
  overflow: hidden;
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ku-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ku-toolbar-actions .el-button {
  margin-left: 0;
}

.ku-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}

.ku-item {
  border: 1px solid #e8eef5;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.ku-add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 158px;
  padding: 12px;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  text-align: center;
}

.ku-add-card .el-button {
  margin: 0;
}

.ku-add-tip {
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.5;
}

.ku-thumb {
  position: relative;
  width: 100%;
  /* 9:16 竖版（与短视频画幅一致） */
  padding-top: 177.78%;
  background: #f1f5f9;
}

.ku-thumb-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}

/* Element 的内层 <img> 只设 object-fit、不给尺寸；不撑满的话窄图会在卡片里留白。
   （音乐占位图那侧用的是内联 object-fit: contain，内联样式优先级更高，不会被这里覆盖） */
.ku-thumb-img /deep/ .el-image__inner {
  width: 100%;
  height: 100%;
}

.ku-thumb-img /deep/ .el-image__placeholder,
.ku-thumb-img /deep/ .el-image__error {
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
  background: #f1f5f9;
}

.ku-play {
  position: absolute;
  z-index: 2;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  background: rgba(99, 99, 99, .1);
}

.ku-play i {
  color: #fff;
  font-size: 38px;
  text-shadow: 0 1px 6px rgba(15, 23, 42, .35);
}

.ku-del,
.ku-down {
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.ku-del {
  top: 4px;
  right: 4px;
  border-radius: 50%;
  background: rgba(100, 116, 139, .72);
}

.ku-del:hover {
  background: #ef4444;
}

.ku-down {
  right: 0;
  bottom: 0;
  border-radius: 10px 0 10px 0;
  background: #64ca0a;
}

.ku-check {
  position: absolute;
  z-index: 3;
  top: 6px;
  left: 6px;
}

.ku-name {
  padding: 6px 8px;
  color: #475569;
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ku-pager {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0 2px;
  border-top: 1px solid #f1f5f9;
  background: #fff;
}

.ku-pager-dialog {
  margin-top: 14px;
}

/* 添加链接弹窗 */
.ku-link-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
}

.ku-link-tip .app-icon {
  flex: none;
  font-size: 17px;
}

.ku-link-panel {
  padding: 14px;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  background: #fff;
}

.ku-link-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.ku-link-label {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.ku-link-label em {
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 9px;
  background: #f1f5f9;
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
}

.ku-link-badges {
  display: flex;
  flex: none;
  gap: 6px;
}

.ku-badge {
  padding: 2px 9px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.ku-badge.is-ok {
  background: #e8f1fe;
  color: #1a73e8;
}

.ku-badge.is-warn {
  background: #fef3c7;
  color: #b45309;
}

.ku-link-input /deep/ .el-textarea__inner {
  border-radius: 8px;
  background: #f8fafc;
  font-size: 13px;
  line-height: 1.75;
}

.ku-link-input /deep/ .el-textarea__inner:focus {
  background: #fff;
}

/* 素材额度进度 */
.ku-quota {
  margin-top: 12px;
}

.ku-quota-track {
  height: 6px;
  border-radius: 4px;
  background: #f1f5f9;
  overflow: hidden;
}

.ku-quota-fill {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #93c5fd, #1a73e8);
  transition: width .25s ease;
}

.ku-quota-fill.is-over {
  background: linear-gradient(90deg, #fca5a5, #ef4444);
}

.ku-quota-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 12px;
}

.ku-quota-over {
  color: #ef4444;
  font-weight: 600;
}

.ku-quota-tip {
  color: #b6c2d2;
}

/* 异步说明条 */
.ku-link-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px dashed #dbe3ec;
  border-radius: 10px;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.7;
}

.ku-link-note .app-icon {
  flex: none;
  margin-top: 1px;
  font-size: 15px;
  color: #cbd5e1;
}

/* 开关卡片 */
.ku-link-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  background: #fff;
}

.ku-link-switch-title {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.ku-link-switch-desc {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
}

/* 分享弹窗：失败原因与说明 */
.ku-share-alert {
  margin-bottom: 12px;
}

.ku-share-tip {
  margin-bottom: 12px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.7;
}

.ku-share-tip b {
  color: #1a73e8;
}

.ku-share-empty {
  margin-top: 16px;
  padding: 14px;
  border: 1px dashed #dbe3ec;
  border-radius: 8px;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
}

.ku-share-unit {
  color: #94a3b8;
  font-size: 12px;
}

/* 批量操作条 */
.ku-batch {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
  padding: 8px 12px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #eff6ff;
}

.ku-batch-count {
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
}

.ku-batch-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ku-batch-actions .el-button {
  margin-left: 0;
}

/* 选中「项目名」时的提示（原「制作完成视频」入口已下线） */
.ku-root-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 1;
  min-height: 200px;
  padding: 24px;
  border: 1px dashed #dbe3ec;
  border-radius: 10px;
  background: #f8fafc;
  color: #94a3b8;
  text-align: center;
}

.ku-root-hint .app-icon {
  font-size: 34px;
  color: #cbd5e1;
}

.ku-root-hint p {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
}

.ku-root-hint b {
  color: #1a73e8;
}

.ku-empty {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

/* 弹窗内的通用行/块 */
.ku-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}

.ku-row-label {
  flex: none;
  color: #475569;
  font-size: 13px;
}

.ku-cover-now {
  display: flex;
  align-items: flex-end;
  gap: 6px;
}

.ku-cover-edit {
  color: #1a73e8;
  font-size: 13px;
  cursor: pointer;
}

.ku-dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 图文素材弹窗：工具条 / 提示 / 空态 */
.ku-cover-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.ku-cover-bar-total {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.ku-cover-bar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ku-cover-bar-actions .el-button {
  margin-left: 0;
}

/* 设置封面：当前封面 + 说明 */
.ku-cover-current {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  background: #f8fafc;
}

.ku-cover-current-label {
  flex: none;
  padding-top: 2px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.ku-cover-current-body {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.ku-cover-current-img {
  flex: none;
  width: 54px;
  height: 90px;
  border-radius: 6px;
  background: #e2e8f0;
  overflow: hidden;
}

.ku-cover-current-none {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 11px;
}

.ku-cover-current-tip p {
  margin: 0 0 3px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.6;
}

/* 当前封面高亮（纯装饰，不挡点击） */
.ku-cover-selected {
  position: absolute;
  z-index: 3;
  inset: 0;
  border: 2px solid #1a73e8;
  border-radius: 6px;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, .15);
  pointer-events: none;
}

.ku-cover-selected i {
  position: absolute;
  right: 4px;
  bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1a73e8;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}

.ku-cover-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;
}

.ku-cover-item {
  text-align: center;
}

.ku-cover-thumb {
  position: relative;
  width: 100%;
  padding-top: 150%;
  cursor: pointer;
}

.ku-cover-thumb /deep/ .el-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: box-shadow .2s;
}

.ku-cover-thumb:hover /deep/ .el-image {
  box-shadow: 0 6px 16px rgba(15, 23, 42, .14);
}

/* Element 的内层 <img> 只设了 object-fit、没有尺寸：不撑满的话图片盖不满缩略框，
   既显示不全，也让"点图看大图"的边缘区域点不到 */
.ku-cover-thumb /deep/ .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 图片加载中/失败的占位 */
.ku-cover-skeleton {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef1f5 25%, #f8fafc 50%, #eef1f5 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
}

.ku-cover-fail {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  font-size: 11px;
  animation: none;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* 设置封面：鼠标移上去才显示"选它"提示 */
.ku-cover-pick {
  position: absolute;
  z-index: 2;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(0, 0, 0, .25);
  opacity: 0;
  transition: opacity .2s;
  /* 装饰层必须让点击穿透：el-image 的预览点击绑在内层 <img> 上，挡住就没反应 */
  pointer-events: none;
}

.ku-cover-thumb:hover .ku-cover-pick {
  opacity: 1;
}

.ku-cover-pick i {
  color: #fff;
  font-size: 26px;
}

/* 图文素材：悬停提示可点开大图 */
.ku-cover-zoom {
  position: absolute;
  z-index: 2;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(15, 23, 42, .32);
  opacity: 0;
  transition: opacity .2s;
  pointer-events: none;
}

.ku-cover-thumb:hover .ku-cover-zoom {
  opacity: 1;
}

.ku-cover-zoom i {
  color: #fff;
  font-size: 24px;
}

.ku-cover-check {
  position: absolute;
  z-index: 3;
  top: 6px;
  left: 6px;
}

.ku-cover-remove {
  position: absolute;
  z-index: 3;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(100, 116, 139, .72);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.ku-cover-remove:hover {
  background: #ef4444;
}

.ku-cover-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  border: 1px dashed #dbe3ec;
  border-radius: 10px;
  background: #f8fafc;
  text-align: center;
}

.ku-cover-empty .app-icon {
  font-size: 34px;
  color: #cbd5e1;
}

.ku-cover-empty p {
  margin: 0;
  color: #475569;
  font-size: 13px;
}

.ku-cover-empty-sub {
  color: #94a3b8 !important;
  font-size: 12px !important;
  line-height: 1.7;
  max-width: 340px;
}

/* 编辑文案弹窗：标题/脚本切换 + 条目卡片 + 内联编辑 */
.ku-title-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.ku-title-tab {
  flex: 1;
  padding: 9px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
  cursor: pointer;
  transition: all .2s;
}

.ku-title-tab:hover {
  border-color: #93c5fd;
  color: #1a73e8;
}

.ku-title-tab.active {
  border-color: #1a73e8;
  background: #1a73e8;
  color: #fff;
}

.ku-title-tab span {
  margin-left: 5px;
  opacity: .75;
  font-size: 12px;
}

.ku-title-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.ku-title-head-text {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.ku-text-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
  padding: 10px 12px;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 13px;
}

.ku-text-item-new,
.ku-text-item-editing {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.ku-text-item-editing /deep/ .el-textarea {
  width: 100%;
}

.ku-text-body {
  min-width: 0;
  max-height: 96px;
  overflow-y: auto;
  color: #334155;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 底部一行：字数靠左、操作靠右 */
.ku-text-side {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ku-text-ops {
  display: flex;
  flex: none;
  align-items: center;
  gap: 2px;
}

.ku-text-len {
  color: #b6c2d2;
  font-size: 11px;
  white-space: nowrap;
}

.ku-text-op {
  padding: 3px 5px;
  border-radius: 6px;
  color: #b6c2d2;
  font-size: 14px;
  cursor: pointer;
  transition: all .2s;
}

.ku-text-op:hover {
  background: #e2e8f0;
  color: #1a73e8;
}

.ku-text-del:hover {
  background: #fee2e2;
  color: #ef4444;
}

.ku-title-editor-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.ku-title-editor-actions .ku-text-len {
  margin-right: auto;
}

.ku-title-empty {
  padding: 22px;
  border: 1px dashed #dbe3ec;
  border-radius: 8px;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
}

/* 视频预览 */
.ku-viewer {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ku-viewer-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .6);
}

.ku-viewer-body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 92vw;
}

.ku-viewer-close {
  position: absolute;
  top: -34px;
  right: 0;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
}

.ku-viewer-body video {
  max-width: 92vw;
  max-height: 68vh;
  border-radius: 8px;
  background: #000;
}

.ku-viewer-name {
  max-width: 88vw;
  overflow: hidden;
  color: #fff;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* el-tree / el-checkbox 细节 */
.ku-page /deep/ .el-tree-node__content {
  height: 44px;
}

.ku-page /deep/ .el-tree-node__content:hover {
  background: #eef4ff;
}

.ku-page /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #e8f1fe;
}

.ku-page /deep/ .el-checkbox__label {
  display: none !important;
}

.ku-page /deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 10px;
}

.ku-page /deep/ .el-checkbox__inner::after {
  top: 4px;
  left: 7px;
}

.ku-page /deep/ .el-pagination.is-background .el-pager li,
.ku-page /deep/ .el-pagination.is-background .btn-next,
.ku-page /deep/ .el-pagination.is-background .btn-prev {
  border-radius: 6px;
}

/* 手机 / 平板 */
@media (max-width: 900px) {
  .tool-page {
    padding: 14px 14px 32px;
  }

  .tool-heading h2 {
    font-size: 19px;
  }

  .tool-heading p {
    display: none;
  }

  .ku-card {
    flex-direction: column;
    /* 手机端恢复由内容撑高，整页滚动；目录栏改用定高抽屉自己滚 */
    height: auto;
    min-height: 0;
  }

  .ku-locked {
    min-height: 320px;
    padding: 32px 16px;
  }

  .ku-pager {
    position: static;
    border-top: 0;
  }

  /* 目录入口做成明显的按钮：浅蓝底 + 描边 + 计数徽标 + 箭头 */
  .ku-dir-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    width: calc(100% - 20px);
    margin: 10px 10px 0;
    padding: 11px 12px;
    border: 1px solid #bfdbfe;
    border-radius: 10px;
    background: #eff6ff;
    color: #1d4ed8;
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    transition: background .2s;
  }

  .ku-dir-toggle:active {
    background: #dbeafe;
  }

  .ku-dir-toggle .app-icon {
    flex: none;
    color: #1a73e8;
    font-size: 18px;
  }

  .ku-dir-label {
    flex: 1;
    min-width: 0;
  }

  .ku-dir-count {
    flex: none;
    padding: 1px 7px;
    border-radius: 10px;
    background: #dbeafe;
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 600;
  }

  .ku-dir-arrow {
    color: #60a5fa !important;
    font-size: 20px !important;
  }

  /* 抽屉里的标题栏与关闭按钮（只在手机显示） */
  .ku-side-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  .ku-side-title {
    padding-top: 14px;
  }

  .ku-side {
    position: fixed;
    z-index: 2001;
    top: 0;
    bottom: 0;
    left: 0;
    width: 82%;
    max-width: 320px;
    height: 100dvh;
    flex: none;
    box-shadow: 12px 0 30px rgba(15, 23, 42, .18);
    transform: translateX(-100%);
    transition: transform .28s ease;
  }

  .ku-side.mobile-open {
    transform: translateX(0);
  }

  .ku-mask {
    display: block;
    position: fixed;
    z-index: 2000;
    inset: 0;
    background: rgba(15, 23, 42, .32);
  }

  /* 「⋯」菜单按钮本身就常驻，触屏无需额外处理 */
  .ku-more-icon {
    width: 26px;
    height: 26px;
  }

  /* 触屏没有 hover：大图提示改为常显，网格更紧凑 */
  .ku-cover-zoom {
    opacity: 1;
    background: rgba(15, 23, 42, .18);
  }

  .ku-cover-pick {
    opacity: 1;
    background: rgba(0, 0, 0, .18);
  }

  .ku-cover-current {
    flex-direction: column;
    gap: 8px;
  }

  .ku-cover-list {
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 8px;
  }

  .ku-cover-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .ku-main {
    padding: 12px 12px 16px;
  }

  .ku-toolbar {
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 12px;
  }

  /* 三个操作按钮并排一行（原来 44% 基础宽度只能放两个，制作视频被挤到第二行） */
  .ku-toolbar-actions {
    width: 100%;
    flex-wrap: nowrap;
    gap: 6px;
  }

  .ku-toolbar-actions .el-button {
    flex: 1 1 0;
    min-width: 0;
    padding: 8px 2px;
    font-size: 12px;
    white-space: nowrap;
  }

  /* 手机端固定 3 列 9:16（原来 auto-fill 120px 只排得下 2 列） */
  .ku-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  /* 3 列后单个格子变窄，上传卡片改为整行通栏（两个按钮并排），避免按钮被挤爆 */
  .ku-add-card {
    grid-column: 1 / -1;
    flex-direction: row;
    gap: 8px;
    min-height: 0;
    padding: 10px;
  }

  .ku-add-tip {
    display: none;
  }

  /* 格子变窄，卡片角标与小字相应收小 */
  .ku-thumb-img,
  .ku-play {
    border-radius: 8px 8px 0 0;
  }

  .ku-check {
    top: 4px;
    left: 4px;
  }

  .ku-del,
  .ku-down {
    width: 22px;
    height: 22px;
    font-size: 12px;
  }

  .ku-play i {
    font-size: 30px;
  }

  .ku-name {
    padding: 5px 6px;
    font-size: 11px;
  }

  .ku-page /deep/ .el-dialog__body {
    padding: 16px 16px 20px;
  }
}

@media (max-width: 480px) {
  .ku-page /deep/ .el-pagination__total {
    display: none;
  }

  .ku-thumb-img {
    border-radius: 8px 8px 0 0;
  }
}
</style>

<style>
/* 弹窗本身挂到 body 之外或由子组件渲染，这里只针对本页弹窗做全局微调 */
@media (max-width: 480px) {
  .ku-dlg {
    width: 94% !important;
    min-width: 0 !important;
  }

  .ku-link-dlg .el-dialog__body {
    padding: 14px 14px 18px;
  }
}

.ku-link-dlg .ku-dialog-footer .el-button {
  min-width: 88px;
}

.ku-upload-dlg .el-upload,
.ku-upload-dlg .el-upload-dragger {
  width: 100% !important;
  box-sizing: border-box;
}

.ku-upload-dlg .el-upload-dragger {
  padding: 20px 10px;
}

.ku-upload-dlg .el-upload-list__item-name {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Ku.vue